module.exports = __webpack_public_path__ + "static/media/surabhisomvanshi.477dd408.jpg";